import theme from '../../styles/themes/default.theme'

const fullWidthIgnorePadding = (padding: number) => {
  return `calc(100% + (2*${theme.spacing(padding)}))`
}

export { fullWidthIgnorePadding }
